import { render, staticRenderFns } from "./EditLibraryFile.vue?vue&type=template&id=4116b104&scoped=true&"
import script from "./EditLibraryFile.vue?vue&type=script&lang=js&"
export * from "./EditLibraryFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4116b104",
  null
  
)

export default component.exports